import Navbar from "../../components/Navbar";
import Contact from "../../components/Contact";
import FAQ from "../../components/FAQ";
import GetStarted from "../../components/GetStarted";
import Footer from "../../components/Footer";

const Support = () => {
    return (
        <>
            <Navbar/>
            <Contact/>
            <FAQ/>
            <GetStarted/>
            <Footer/>
        </>
    )
}

export default Support;